module.exports = __webpack_public_path__ + "img/lobby_hosting_zgw2.8c8edd2e.png";